<template>
  <CRow>
    <CCol col="12">
      <CCard no-header>
        <CCardBody>
          <div class="row">
            <div class="col-3">
              <CInput readonly :label="$t('report_type')" type="text" v-model="report.type"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('product')" type="text" v-model="report.product"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('driver')" type="text" v-model="report.driver"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('user')" type="text" v-model="report.user"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <CInput readonly :label="$t('generate_by')" type="text" v-model="report.generate_by_driver"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('time_filter')" type="text" v-model="report.time_filter"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('bottles_dispatched')" type="text" v-model="report.bottles_dispatched"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('empty_bottles')" type="text" v-model="report.empty_bottles"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <CInput readonly :label="$t('bottles_full_back')" type="text" v-model="report.bottles_full_back"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('damaged_bottles')" type="text" v-model="report.damaged_bottles"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('total_credit_cards')" type="text" v-model="report.total_credit_cards"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('total_checks')" type="text" v-model="report.total_checks"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <CInput readonly :label="$t('total_pending_credits')" type="text" v-model="report.total_pending_credits"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('total_bottles')" type="text" v-model="report.total_bottles"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('total_sold')" type="text" v-model="report.total_sold"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('weekly_income')" type="text" v-model="report.weekly_income"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <CInput readonly :label="$t('active')" type="text" v-model="report.active"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('prepared')" type="text" v-model="report.prepared"></CInput>
            </div>
            <div class="col-3">
              <CInput readonly :label="$t('created_at')" type="text" v-model="report.created"></CInput>
            </div>
            <div class="col-3">
            </div>
          </div>
          
          <CButton color="primary" @click="goBack">
            <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
          </CButton>
        </CCardBody>
      </CCard>
  </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Vue from "vue";
import list from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import { cilArrowLeft } from '@coreui/icons';

Vue.filter('toCurrency', function (value) {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

export default {
  name: 'Report',
  mixins: [list, localeMixin],
  backIcon: cilArrowLeft,
  data() {
    return {
      report: '',
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    this.getReport(this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Reports" });
    },
    getReport(id) {
        let self = this;
      axios.get('/api/report/' + id + '?token=' + localStorage.getItem("api_token"))
      .then(response => {
          self.report = response.data;
      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    },
  }
}


</script>

<style scoped>
.dropdown {
  display: inline-block;
}
.dropdown-menu {
  left: auto !important;
  right: 0;
}
.dropdown-menu.top {
  top: auto !important;
  bottom: 100%;
  margin-bottom: 5px;
}
.table-dropdown-fix tr:nth-last-child(-n+2) .dropdown-menu {
  top: auto !important;
  bottom: 100%;
  margin-bottom: 5px;
}
</style>
